import React from 'react';
import GoogleMeSis from "../assets/ImagesofApp/AppImages2.png";

function GoogleMe() {
  return (
    <section className='bg-[#F7F3F2]'>
      <div
        style={{
          clipPath: 'polygon(0 0, 100% 0, 100% 90%, 0 100%)',
          backgroundColor: '#2E2D2B',
          padding: '20px',
          width: '100%',
        }}
      >
        <div className="mx-auto w-full max-w-7xl px-5 py-12 md:py-16">
          <div className="grid items-center gap-10 md:gap-20 md:grid-cols-2">
            <div className='max-w-md mx-auto md:mx-0 text-center md:text-left'>
              <h2 className="mb-6 text-2xl font-bold md:text-3xl md:leading-snug uppercase text-white">
                Build Your MVP — Without the Overwhelm
              </h2>
              <p className="mb-8 max-w-lg text-sm text-white sm:text-base md:mb-10 font-light">
                Are you a visionary woman founder with an app idea waiting to be built? Whether you're launching a membership hub, client portal, or niche community platform, I help female-led startups bring their MVPs to life — fast, functional, and beautifully branded.
<br/>
Let’s turn your idea into a working product — and get it in front of the people who need it.
              </p>
              <div className="flex justify-center md:justify-start">
                <a href='/clientwork'>
                  <button className="text-black bg-[#CFF098] rounded-full px-6 py-3 border-[1px] border-black">See Example Projects →</button>
                </a>
              </div>
            </div>
            <div>
              <img src={GoogleMeSis} alt="App preview mockup" className="mx-auto inline-block w-[800px]" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default GoogleMe;
